var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendMessage = function SvgSendMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M20.072 10.184 6.557 2.776a2.08 2.08 0 0 0-2.29.171 2.1 2.1 0 0 0-.779 2.174L4.878 11a.4.4 0 0 0 .391.308l8.738-.038h.004a.75.75 0 0 1 .003 1.5l-8.756.039a.4.4 0 0 0-.387.308L3.488 18.96a2.1 2.1 0 0 0 .778 2.176c.38.29.826.436 1.275.436.345 0 .694-.087 1.016-.264l13.515-7.408a2.09 2.09 0 0 0 1.099-1.859 2.09 2.09 0 0 0-1.1-1.858",
    clipRule: "evenodd"
  })));
};
export default SvgSendMessage;